export default __webpack_public_path__ + "8fad2e587b56a47891bcd2e83bbfae32.png";